var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgua(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.0007 89.8334C67.931 89.8334 81.6673 75.6724 81.6673 56.1623C81.6673 30.7149 52.6022 9.80009 51.3649 8.92217C50.6754 8.43286 49.8509 8.16968 49.0054 8.16895C48.1599 8.16822 47.335 8.42997 46.6446 8.91809C45.4073 9.78784 16.334 30.6373 16.334 56.1459C16.334 75.6643 30.0703 89.8334 49.0007 89.8334ZM48.9966 17.3951C55.5503 22.6626 73.5007 38.6856 73.5007 56.1623C73.5007 71.1808 63.423 81.6668 49.0007 81.6668C34.5783 81.6668 24.5007 71.1726 24.5007 56.1459C24.5007 38.6284 42.4428 22.6503 48.9966 17.3951Z",
    fill: "#DA0067"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgua);
export default __webpack_public_path__ + "static/media/agua.0e2d7c38968e904cbdd2f58f7859a61c.svg";
export { ForwardRef as ReactComponent };